import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://diiotcore.com';

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000
});

export default apiClient;
